import { useState } from 'react';

import useSWR from 'swr';

import Box from '@mui/material/Box';

import Grid from '@mui/material/Grid';

import ImageCard from '../../components/ImageCard';
import { getTranslation } from '../../utils/translate';
import ListPage from '../../layouts/ListPage';
import useCountInJunction from '../../common/hooks/useCountInJunction';
import { pageNumber, pageSize } from '../../utils/pagination';
import { languages } from '../../utils/translate';

const ArticleList = () => {
    const [page, setPage] = useState(pageNumber);
    const [language, setLanguage] = useState(languages[0]);

    const filter = {
        _and: [
            {
                status: {
                    _eq: 'published'
                }
            },
        ]
    };

    const { data: pageData, isLoading: pageDataLoading } = useSWR({
        url: 'pages?meta=*',
        fields: [
            '*',
            'translations.*',
        ],
        filter,
        sort: '-date_created',
        limit: pageSize,
        page,
    });

    const articleCount = useCountInJunction(
        'pages',
        {
            aggregate: {
                count: '*'
            },
            filter,
        },
        pageDataLoading,
    );

    const summaryValues = [
        {
            label: 'Total',
            value: pageData?.meta?.filter_count || articleCount || '-'
        },
    ];

    return (
        <ListPage
            title='Articles'
            summaries={summaryValues}
            searchStorageKey={'articles'}
            handleSearchComplete={() => { }}
            searchOnly={['ARTICLES']}
            breadcrumbsLinks={[
                {
                    url: '/cba-menu',
                    content: 'Canada Beef Advantage'
                }
            ]}
            pageNumber={page}
            setPageNumber={setPage}
            numberOfPages={Math.ceil(pageData?.meta?.filter_count / pageSize)}
            loading={pageDataLoading}
            language={language}
            setLanguage={setLanguage}
        >
            <Box sx={{ flexGrow: 1, my: 3 }}>
                <Grid sx={{ mt: 4 }} container spacing={2}>
                    {pageData?.data?.map(item => (
                        <Grid
                            item
                            key={item.id}
                            xs={6}
                            sm={4}
                            md={4}
                            lg={3}
                            xl={2}
                        >
                            <ImageCard
                                url={`/articles/${item.id}`}
                                item={{
                                    title: getTranslation(item, { key: 'languages_code', code: language.code }).title,
                                    description: getTranslation(item, { key: 'languages_code', code: language.code }).summary,
                                    url: item.image ? `${process.env.REACT_APP_API_URL}/assets/${item.image}` : null,
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </ListPage>
    )
}

export default ArticleList